// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> the-alden-south-hills
// Generated: 2026-10-22T20:05:22.236Z
// Counts: 1 design, 68 content, 68 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 3 Bedroom Apartments for Rent in Pittsburgh , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>The Alden South Hills</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Alden South Hills, where vibrant living meets a rich tapestry of nearby attractions! From the serene landscapes of South Park to educational excellence at local schools, enjoy easy access to family-friendly parks, cultural hubs like the Pittsburgh Zoo, and convenient shopping. Your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>The Alden South Hills</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Alden South Hills in Pittsburgh, where modern living meets vibrant community life. From spacious <a href=\"https://www.livethealdensouthhills.com/floor-plans/\">floor plans</a> —including studios and townhomes—to fantastic amenities like a basketball court, fitness center, and pet-friendly spaces, your ideal lifestyle awaits. Dive into comfort and convenience today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in Pittsburgh, PA, finding the perfect apartment is effortless. Choose from studio to three-bedroom layouts, and enjoy amenities like a serene dog park, vibrant clubhouse, and a refreshing swimming pool. Lease online today and elevate your lifestyle in our welcoming community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in Pittsburgh, PA, our diverse <a href=\"https://www.livethealdensouthhills.com/floor-plans/\">floor plans</a> cater to your lifestyle—ranging from cozy studios to spacious three-bedroom apartments. Each home is designed for comfort and convenience. Have questions? Contact our leasing team today to find the perfect fit for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in vibrant Pittsburgh, PA, each thoughtfully designed floor plan—ranging from cozy studios to spacious three-bedroom apartments—invites you to envision your ideal lifestyle. Browse our available options and find the perfect layout that suits your needs and aspirations. Your dream apartment awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in Pittsburgh, PA, vibrant living converges with modern comforts. From cozy studios to spacious townhomes, our community offers something for everyone. Enjoy an outdoor lounge, fitness center, and pet-friendly amenities. Picture yourself relaxing by the pool or engaging in resident activities—your dream lifestyle awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Alden South Hills, where vibrant living meets a rich tapestry of nearby attractions! From the serene landscapes of South Park to educational excellence at local schools, enjoy easy access to family-friendly parks, cultural hubs like the Pittsburgh Zoo, and convenient shopping. Your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Pittsburgh , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We love pets and happily welcome dogs, cats, and service animals to our community. Breed and weight restrictions apply; please contact the leasing office for details. A one‑time, non‑refundable pet fee of $350 is due at move‑in, and monthly pet rent is $50 per pet (or $75/month for 2 pets). We allow up to 2 pets per home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for a home that matches your personal style? Look no further than the pet-friendly studio, one, two, and three bedroom apartments at The Alden in the heart of Pittsburgh, Pennsylvania. Experience all the perks of suburban living while also enjoying access to downtown Pittsburgh with the convenience and comfort of a modern apartment home. You’ll enjoy in-home features like large closets and a new gourmet-style kitchen with a breakfast bar as well as a host of community benefits.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in Pittsburgh, PA, elevate your living experience with versatile floor plans ranging from cozy studios to spacious three-bedroom apartments. Seamlessly manage your home life—log in to our resident portal for effortless rent payments and maintenance requests, ensuring your comfort comes first.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills, your perfect home awaits in Pittsburgh, PA! Whether you’re drawn to our cozy studios or spacious three-bedroom apartments, each floor plan is designed with comfort and style in mind. Schedule a tour today and hear firsthand from our residents about their vibrant community life!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out! At The Alden South Hills in Pittsburgh, PA, we offer an array of thoughtfully designed floor plans—studios to three bedrooms—tailored to suit your lifestyle. A member of our team will be in touch soon to help you find your perfect home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Alden South Hills in Pittsburgh, PA, our thoughtfully designed apartments cater to every lifestyle. Whether you're seeking a cozy studio or an expansive three-bedroom layout, our floor plans are tailored for comfort and convenience. Immerse yourself in our vibrant community—take a virtual tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-1324-70af-8c4e-4aa6d3b27d12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room in a modern apartment with a beige sofa, blue armchair, coffee table, and window at The Alden South Hills in Pittsburgh, PA."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-2bac-76af-8107-fc1d3574f005.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Common lounge area with a stone fireplace, wall-mounted TV, and tan seating at The Alden South Hills in Pittsburgh, PA."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-33d4-71fc-a2e8-a5646bc0fd99.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior fitness center with two treadmills and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026a-fc12-71bb-b483-40a97a12bc9d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with weight machine and stationary bike in an orange-walled room."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026a-eb57-750a-bcc7-296595fc5277.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Common lounge area with a stone fireplace, wall-mounted TV, and tan seating."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026a-c356-77a3-baf8-bac39acd7b39.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark wood cabinets, black appliances, and a granite island with seating."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-26d0-71a8-ac71-286018c17a98.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a dark gray sofa, coffee table, curtains, TV stand, and a plant."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-262b-72cd-b83a-2c1c377f4a8f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in a modern apartment with a bed, dresser, and a leaning floor mirror."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166347/01a015db-c3c2-706b-8e59-43c95d401ca8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of the apartment buildings at The Alden South Hills with a mature tree and manicured lawn in Pittsburgh, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-5e5b-77ec-af56-ba7f3828c10a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "South Hills Village mall, a nearby shopping destination with upscale and mainstream stores."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-6fc4-728c-96df-6cddf8620926.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "South Park, a sprawling county park with trails, sports fields, and green space near the community."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026b-a970-728a-95fa-80825de16bc8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pittsburgh Botanic Garden, with themed gardens and woodland walking trails nearby."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-362f-762a-8ce0-505f86ee843a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor apartment community pool at dusk with lounge chairs and brick buildings in background at The Alden South Hills in Pittsburgh, PA."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026a-fc43-7090-a775-8c8bfd5dc027.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool with lounge chairs and brick surround at dusk."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026a-e400-7707-928a-750f82e982d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community pool with lounge chairs, surrounded by trees and brick buildings."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019d026d-3365-7129-83f4-d28f3f5e87c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with a slide and climbing structure at a residential complex on a wood-chip surface."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$125"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_custom": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Single Garage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$65"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.parking_garage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Garage-Large Parking"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$35"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent — 2nd Pet"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$15"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce6e-ac0c-7419-a118-79fdc51434f6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce6e-ad25-714e-950d-6e290430cd90.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce6e-ad44-70df-bc46-9ce4b63c6630.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce6e-aeb9-701a-a02c-102b25eb3106.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce6e-b668-719f-ba80-cd7c29680b8a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-657a-740c-86dd-4b58877cac54.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Carnegie Coffee Company"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Hip, lofty coffeehouse in a former post office with Italian espresso & pastries, plus Sunday brunch."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-75e5-7671-9014-3aab547fac60.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "South Hills Village"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Mall with upscale & mainstream shops, department stores, a cinema, a food court & restaurants."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-ae68-7682-9f9d-205932a7ebdc.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Pittsburgh Botanic Garden"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Gardens"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "12.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Themed gardens, a dogwood meadow & woodlands with a lotus pond, laced with walking trails."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-536c-739c-842c-5584328a36bd.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Waffles, INCaffeinated, Upper St. Clair"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Creatively topped waffles are the draw at this breakfast spot also dishing up eggs & crêpes."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-9267-73ef-9e30-a40702730cf4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Senator John Heinz History Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Smithsonian affiliate has 6 floors of historical exhibits, archives & a separate sports museum."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-863a-70ba-913e-e733a480e12c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "South Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "South Park County's 1,999-acre park offers sports, a wave pool, trails & a tourable old farmhouse."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5a3e-77b0-8776-044774ee04f6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bonefish Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Cocktails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-7ff7-7538-afc7-3371162b502b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Crafthouse Stage & Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Buzzy venue offering live music, pub grub & many craft beers on tap, plus a cigar bar & dance floor."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-5bb9-747d-8339-6dfa799fad81.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bella's On Fort Couch"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner & Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Established outpost for homemade ravioli & other classic Italian dishes served in a relaxed setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-59e7-7358-beeb-56117ef04c95.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Gather Restaurant Pittsburgh"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Cocktails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual, modern hotel eatery serving American comfort staples plus cocktails & craft beers."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-8443-74ef-ba79-181b2757d0ee.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "AMC CLASSIC South Hills Village 10"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "8.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166347/019fce0b-63b4-715f-b1dc-96d7dfe702ae.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Eat'n Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Family-friendly diner chain serving up all-day comfort food & signature Smiley Cookies."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_a0ddead3-e3f0-4474-abc3-f9f4488e1c09",
      "custom_3dea6b88-8bee-44c9-8d98-1f8960b97ef3",
      "custom_83247353-5085-457e-8e95-d290e70ba679",
      "custom_ef138fd2-7db7-43ac-962c-fecfee832963",
      "custom_871362c8-c820-4fdd-980f-d7c2fa7da06a",
      "custom_23e10349-a8b7-4bcb-a11e-378c23c316e4",
      "custom_9d3b60df-167e-4b10-b969-ed8f0d573459",
      "custom_81758483-3464-4848-843b-da5b4d383ae4",
      "custom_a1848208-1c42-4f01-a1ea-2a99c90f1c52",
      "custom_aec7caac-f67d-468f-982c-1ec22f596454",
      "custom_9824e9c2-1878-43b3-8b0f-6da8aee4d8c1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
